import { currencyOptions } from 'home/Settings/siteProfile.constants';

/**
 * Get currency symbol from currency code
 * @param {string} currency - Currency code (USD, CAD, EUR, INR)
 * @returns {string} Currency symbol ($, $, €, ₹)
 */
export const getCurrencySymbol = (currency = 'USD') => {
  const currencyOption = currencyOptions.find(opt => opt.value === currency);
  return currencyOption ? currencyOption.symbol : '$';
};

/**
 * Format amount with currency symbol
 * @param {number|string|null|undefined} amount - Amount to format
 * @param {string} currency - Currency code (default: 'USD')
 * @param {object} options - Formatting options
 * @param {number} options.decimals - Number of decimal places (default: 2)
 * @param {boolean} options.showSymbol - Whether to show currency symbol (default: true)
 * @param {string} options.symbolPosition - 'prefix' or 'suffix' (default: 'prefix')
 * @returns {string} Formatted currency string (e.g., "$123.45", "€123.45")
 */
export const formatCurrency = (amount, currency = 'USD', options = {}) => {
  const {
    decimals = 2,
    showSymbol = true,
    symbolPosition = 'prefix'
  } = options;

  if (amount === null || amount === undefined || amount === '') {
    const symbol = getCurrencySymbol(currency);
    return showSymbol ? `${symbol}0.00` : '0.00';
  }

  const numericAmount = typeof amount === 'string' ? parseFloat(amount) : amount;

  if (isNaN(numericAmount)) {
    const symbol = getCurrencySymbol(currency);
    return showSymbol ? `${symbol}0.00` : '0.00';
  }

  const formattedAmount = numericAmount.toFixed(decimals);
  const symbol = getCurrencySymbol(currency);

  if (symbolPosition === 'suffix') {
    return showSymbol ? `${formattedAmount} ${symbol}` : formattedAmount;
  }

  return showSymbol ? `${symbol}${formattedAmount}` : formattedAmount;
};

/**
 * Get currency code from Redux state
 * @param {object} state - Redux state object
 * @returns {string} Currency code ('USD', 'CAD', 'EUR', 'INR')
 */
export const getCurrencyFromState = (state) => {
  if (!state || !state.currentAccount || !state.currentAccount.preferences) {
    return 'USD';
  }
  return state.currentAccount.preferences.currency || 'USD';
};
